<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{dialogTitle | translate}}</span>
            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-8 m-0" fusePerfectScrollbar>

        <form autocomplete="off" [formGroup]="complaintForm">

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>{{'Complaint Type' | translate }}</mat-label>
                    <mat-select formControlName="type" required #complaintType
                        (selectionChange)='checkTypeChange(complaintType)'>
                        <mat-option *ngFor="let complaintType of complaintTypes" [value]="complaintType.id">
                            {{complaintType.name | translate}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="checkServerError('type')"> {{checkServerError('type')}}</mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>{{'Comment' | translate }}</mat-label>
                    <!-- <input name="comment" formControlName="comment" matInput> -->
                    <textarea matInput required name="comment" formControlName="comment" #comment
                        placeholder="{{'Type your comment' | translate }}" cdkTextareaAutosize cdkAutosizeMaxRows="6"
                        cdkAutosizeMinRows="4" maxlength="200" [matTextareaAutosize]="true"></textarea>
                    <mat-hint>{{comment.value.length || 0}}/200</mat-hint>
                    <mat-error *ngIf="checkServerError('comment')"> {{checkServerError('comment')}}</mat-error>
                </mat-form-field>
            </div>

        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <!-- <button mat-button class="save-button text-uppercase" (click)="createComplaint(complaintForm, 'edit')" [disabled]="complaintForm.invalid || complaintForm.pristine"
            aria-label="SAVE" *ngIf="action === 'edit'">
            {{'Save' | translate }}
        </button> -->

        <button mat-raised-button color="primary" class="save-button text-uppercase" (click)="createComplaint(complaintForm, 'new')"
            [disabled]="complaintForm.invalid" aria-label="SAVE" *ngIf="action === 'new'">
            {{'Add' | translate }}
        </button>

    </div>
</div>